var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustomIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_18966",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 18966",
    transform: "translate(-3857 18226)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "star",
    transform: "translate(3857 -18225)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_29219",
    "data-name": "\\u30D1\\u30B9 29219",
    d: "M20.855,1.175,25.092,9.67a2.116,2.116,0,0,0,1.593,1.149L36.176,12.2a2.126,2.126,0,0,1,1.4.816,2.055,2.055,0,0,1,.4,1.55,2.1,2.1,0,0,1-.61,1.2l-6.881,6.663a2.011,2.011,0,0,0-.61,1.832l1.695,9.378a2.118,2.118,0,0,1-1.695,2.415,2.22,2.22,0,0,1-1.356-.217l-8.474-4.414a2.22,2.22,0,0,0-2,0L9.568,35.838a2.172,2.172,0,0,1-2.915-.849,2.149,2.149,0,0,1-.22-1.333l1.695-9.378a2.011,2.011,0,0,0-.61-1.832L.636,15.783a2.057,2.057,0,0,1,0-2.965,2.064,2.064,0,0,1,1.22-.6l9.491-1.383A2.116,2.116,0,0,0,12.94,9.687l4.084-8.512A2.106,2.106,0,0,1,18.957.009h.254A2.116,2.116,0,0,1,20.855,1.175Z",
    transform: "translate(0.005 0.008)",
    fill: "#200e32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_29220",
    "data-name": "\\u30D1\\u30B9 29220",
    d: "M19.012,31.182a2.306,2.306,0,0,0-1.05.286l-8.447,4.4A2.207,2.207,0,0,1,6.657,35a2.084,2.084,0,0,1-.22-1.316l1.695-9.361a2.093,2.093,0,0,0-.61-1.849l-6.9-6.663a2.073,2.073,0,0,1,0-2.965,2.166,2.166,0,0,1,1.2-.6l9.525-1.4a2.062,2.062,0,0,0,1.593-1.149l4.138-8.609A2.112,2.112,0,0,1,19.029.017C19.012.583,19.012,30.8,19.012,31.182Z",
    transform: "translate(0 0)",
    fill: "#200e32"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_18965",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 18965",
    transform: "translate(123 12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_18962",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 18962",
    transform: "translate(-70 12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_17430",
    "data-name": "\\u9577\\u65B9\\u5F62 17430",
    width: 38,
    height: 38,
    transform: "translate(3804 -18250)",
    fill: "none"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomIcon);
export default __webpack_public_path__ + "static/media/customIcon.e4a78444d757b6dec09ebb026c287b0e.svg";
export { ForwardRef as ReactComponent };